<script lang="ts">
  import { format_duration } from "../time";

  export let trainingAdvice;

  let programType
  let programWarning;
  let programActive;

  $: if (trainingAdvice) {
    programType = trainingAdvice.program.type;
    if (trainingAdvice.phase.startsWith("Pre Base")) {
      programWarning = '<span class="tooltip-icon"><i class="fa fa-warning"></i><span class="tooltip-manual">Your Training Program has not started.</span></span>';
      programActive = false;
    } else if (trainingAdvice.phase.startsWith("Post Event")) {
      programWarning = '<span class="tooltip-icon"><i class="fa fa-warning"></i><span class="tooltip-manual">Your Training Program has ended.</span></span>';
      programActive = false;
    } else {
      programActive = true;
      if (trainingAdvice.phase.startsWith("Taper Week") && trainingAdvice.training_gradient > 0) {
        programWarning = '<span class="tooltip-icon"><i class="fa fa-warning"></i><span class="tooltip-manual">You are in your Taper Week and Improvement Rate is currently set too high.  Reduce to Maintenance or lower.</span></span>';
      }
    }
  }
</script>

<div class="subtext deficit-surplus">
  <span class="title">
    {#if trainingAdvice}
      {"Training " + (trainingAdvice.xss_deficit > 0 ? 'Deficit ' : 'Surplus ')}
      <a href="http://www.baronbiosys.com/glossary/training-deficits-and-surpluses" target="_help">
      <span class="tooltip-icon"><span class="fa-regular fa-circle-question"></span ></span ></a> :
    {/if}
  </span>
  <span class="value">
    <strong> {Math.abs(trainingAdvice.xss_deficit).toFixed(0)} XSS </strong>
    {#if trainingAdvice.progress_indicator < -0.4}
      <span class="tooltip-icon">
        <i class="fa fa-warning"></i>
        <span class="tooltip-manual">You have fallen behind. Increase your training volume or reduce your Improvement Rate.</span >
      </span >
    {/if}
  </span>
</div>
<div class="subtext deficit-guide">
  {#if trainingAdvice}
    {#if programType == "continuous"}
      Program <a href="http://www.baronbiosys.com/glossary/program-type" target="_help">
      <span class="tooltip-icon"><span class="fa-regular fa-circle-question"></span></span></a> : <strong>Continuous Improvement</strong><br>
    {:else if programType == "challenge"}
      Program <a href="http://www.baronbiosys.com/glossary/program-type" target="_help">
      <span class="tooltip-icon"><span class="fa-regular fa-circle-question"></span></span></a> : <strong>30 Day Challenge</strong><br>
    {:else}
      Program <a href="http://www.baronbiosys.com/glossary/program-phases" target="_help">
      <span class="tooltip-icon"><span class="fa-regular fa-circle-question"></span></span></a> : Target Event - <strong>{trainingAdvice.phase}</strong> Phase {#if programWarning}{@html programWarning}{/if}<br>
    {/if}
    {#if trainingAdvice.availability != 0}
      {#if !(programActive && programType == "targetEvent") || (trainingAdvice.recommended_athlete == "Endurance") || (trainingAdvice.recommended_athlete == "Recovery")}
        Focus Type <a href="http://baronbiosys.com/understanding-focus-and-how-to-use-it/" target="_help">
        <span class="tooltip-icon"><span class="fa-regular fa-circle-question"></span></span></a> : <strong>{trainingAdvice.recommended_athlete}</strong>
        <br>
      {:else}
        Focus Type <a href="http://baronbiosys.com/understanding-focus-and-how-to-use-it/" target="_help">
        <span class="tooltip-icon"><span class="fa-regular fa-circle-question"></span></span></a> : <strong>{trainingAdvice.recommended_spec_rating} {trainingAdvice.recommended_athlete}</strong>
        <br>
      {/if}
      Difficulty Rating: <strong><span class="diamond">{@html trainingAdvice.difficulty_rating}</span></strong>
      <br>
      Availability: <strong>{Math.round(trainingAdvice.availability*10)/10} 
        {#if Math.round(trainingAdvice.availability*10)/10 == 1} 
        hour 
        {:else} 
        hours
        {/if}
      </strong><br>
    {:else}
      Availability: <strong>Rest Day</strong><br>
    {/if}
    {#if trainingAdvice.daily_goal_complete == 'all' || trainingAdvice.form_cat == "Very tired"}
    Optional
    {:else if trainingAdvice.daily_goal_complete == 'some'}
    Remaining 
    {:else}
    Recommended
    {/if}
    XSS <a href="https://baronbiosys.com/glossary/recommended-xss/" target="_help">
      <span class="tooltip-icon"><span class="fa-regular fa-circle-question"></span></span></a> :
      <b>
          {trainingAdvice.xss_goal.toFixed(0)}
          <span class="whitespace-nowrap">
            {'('}
            <span class="nlow">{trainingAdvice.targetXSS.xlss.toFixed(0)}</span>
            {' | '}
            <span class="nhigh">{trainingAdvice.targetXSS.xhss.toFixed(1)}</span>
            {' | '}
            <span class="npeak">{trainingAdvice.targetXSS.xpss.toFixed(1)}</span>
            {')'}
          </span>
      </b>  
    {/if}

    <!-- Extra Status Data -->
    <slot />
</div>

<style lang="scss">
      .npeak {    
          color: var(--color-xpss);
      }
      .nlow {
          color: var(--color-xlss);
      }
      .nhigh {
          color: var(--color-xhss);
      }
</style>
